import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class MatchedContractsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/matched_contracts", { params: toSnakeCase(params) });
  }
}

export default new MatchedContractsService();
